module.exports = __webpack_public_path__ + "static/img/组 11.edaccb4f.png";